<template>
    <el-drawer
        :title="!id ? '新增房间节目' : '编辑房间节目'"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content">
            <el-form
                :model="formData"
                :rules="rules"
                ref="formData"
                label-position="top"
                v-loading="dataLoading"
            >
                <el-form-item prop="name" label="节目名称:">
                    <el-input
                        v-model="formData.name"
                        placeholder="请输入节目名称"
                        size="medium"
                    ></el-input>
                </el-form-item>
                <el-form-item prop="liveRoomIds" label="绑定直播间:">
                    <el-input
                        type="textarea"
                        v-model="formData.liveRoomIds"
                        placeholder="请输入绑定直播间,多个ID以英文逗号分隔"
                        size="medium"
                    ></el-input>
                    <small class="from-tip"><span class="el-icon-warning"></span> ID间请使用英文逗号隔开</small>
                </el-form-item>
                <el-form-item prop="liveEventIdsArry" label="绑定事件:">
                    <el-select
                        v-model="formData.liveEventIdsArry"
                        multiple
                        filterable
                        remote
                        reserve-keyword
                        placeholder="请输入绑定事件标题"
                        :remote-method="searchEvent"
                        :loading="eventLoading"
                        size="medium">
                        <el-option
                        v-for="item in eventList"
                        :key="item.id"
                        :label="item.title"
                        :value="item.id">
                        </el-option>
                    </el-select>
                    <small class="from-tip"><span class="el-icon-warning"></span> 请输入事件标题进行搜索</small>
                </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                >提交</el-button
            >
        </div>
    </el-drawer>
</template>

<script>
const defaultFormData = {
    name: "",
    liveRoomIds:'',
    liveEventIds:'',
    liveEventIdsArry:[]
}
export default {
    data() {
        return {
            drawerShow: false,
            dataLoading: false,
            btnLoading:false,
            formData: {
                ...defaultFormData
            },
            rules: {
                name: [{ required: true, message: "请输入节目名称" }],
                liveRoomIds: [{ required: true, message: "请输入绑定直播间" }],
                liveEventIdsArry: [{ required: true, message: "请输入绑定直播事件" }],
            },
            id:'',
            eventList:[],
            eventLoading: false
        };
    },
    methods: {
        close() {
            this.formData = {...defaultFormData};
            this.eventList=[];
            this.$refs.formData.resetFields();
            this.drawerShow = false;
        },
        show(id) {
            this.id = id;
            if(this.id){
                this.getDataDetail();
            }
            this.drawerShow = true;
        },
        //获取详情
        getDataDetail() {
            this.dataLoading = true;
            this.$request({
                url: "/live/roomProgram/detail",
                params: { id: this.id },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        const _arry = result.liveEventIds.split(',');
                        _arry.forEach((v,i) => {
                            _arry[i] = parseInt(v)
                        })
                        this.formData = {
                            ...result,
                            liveEventIdsArry: _arry
                        };
                        
                        this.eventList = result.liveEvents;
                        
                    } else {
                        self.$message.error(msg || "操作失败,请重试");
                    }
                })
                .catch(() => {
                    self.$message.error("操作失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        //搜索直播事件
        searchEvent(query){
            if(query !== ""){
                this.eventLoading = true;
            this.$request({
                url: "/live/event/list",
                data: {pageNo: 1,pageSize: 100,title:query},
                method: "post",
            })
                .then((res) => {
                    const { state, result } = res.data;
                    if (state == 1 && result) {
                        this.eventList = result.result
                    }
                })
                .finally(() => {
                    this.eventLoading = false;
                });
            }
        },
        //表单提交
        submitForm() {
            let self = this;
            
            self.$refs["formData"].validate((valid) => {
                if (valid) {
                    
                    const _url = this.id
                        ? "/live/roomProgram/update"
                        : "/live/roomProgram/create";
                    this.btnLoading = true;
                    
                    this.formData.liveEventIds = this.formData.liveEventIdsArry+'';    

                    this.$request({
                        url: _url,
                        data: this.formData,
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.$emit('update');
                                self.close();
                            } else {
                                self.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            self.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                } else {
                    return false;
                }
            });
        },
    },
};
</script>
